import { Avatar } from "antd";
import { memo } from "react";
import styled from "styled-components";

const MemberItem = () => {
  return (
    <UI_Wrapper>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <Avatar />
        <div>
          <UI_Fullname>Luận Tạ Minh</UI_Fullname>
          <UI_Email>ngoalongtb001@gmail.com</UI_Email>
        </div>
      </div>
      <div style={{ width: 50, fontSize: 12, color: '#333' }}>Owner</div>
    </UI_Wrapper>
  )
}

export default memo(MemberItem);

const UI_Wrapper = styled.div`
  display: flex;
  padding: 8px 0px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`

const UI_Fullname = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
`

const UI_Email = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
`


